<template>
  <v-list class="ma-0 pa-0">
    <template v-for="(item, i) in templates">
      <v-list-item
        :key="i"
        @click="input(item)"
        :class="isActive(item) ? 'primary' : ''"
        :dark="isActive(item)"
      >
        <v-list-item-title>
          {{ item.name }}
        </v-list-item-title>
      </v-list-item>
      <v-divider :key="'divider-' + i"></v-divider>
    </template>
  </v-list>
</template>

<script>
export default {
  props: {
    value: String
  },
  data() {
    return {
      id: ""
    };
  },
  computed: {
    templates() {
      return this.$store.getters.templates.filter(item => {
        return item.type == 0;
      });
    }
  },
  methods: {
    isActive({ id }) {
      return this.id == id;
    },
    input({ id }) {
      const vm = this;
      vm.id = id;
      vm.$emit("input", id);
    }
  },
  mounted() {
    this.id = this.value;
  }
};
</script>

<style></style>
